import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100vh',
}));
const StyledContent = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
}));
const StyledText = styled(Typography)(() => ({
  marginBottom: '1rem',
  maxWidth: '80%',
  textAlign: 'center',
}));

const AssetViewComponent = (props) => {
  const { getAssetContent } = props;
  const { title, subtitle, content } = getAssetContent();
  return (
    <StyledContainer>
      <StyledText variant="h4">{title}</StyledText>
      <StyledText variant="h6">{subtitle}</StyledText>
      <StyledContent>{content}</StyledContent>
    </StyledContainer>
  );
};

AssetViewComponent.propTypes = {
  getAssetContent: PropTypes.func.isRequired,
};

export default AssetViewComponent;
